export class RegistrationResponse {
    public isPending: boolean;
}
